import styled from 'styled-components'
import Flex from '../../layout/Flex'

const MessagesContainer = styled(Flex)`
    background: ${({ theme: { messages: { colors } } }) => colors.background};
`

export default MessagesContainer
